<div style="min-width: 600px">
    <form [formGroup]="formGroup">
        <formly-form [model]="section" [fields]="fields" [form]="formGroup">
        </formly-form>
    </form>
    <p-panel>
        <ng-template pTemplate="header">
            <div class="grid w-12">
                <div class="col-8">
                    <div class="pt-2">Total {{section.cards?.length}} items.</div>
                </div>
                <div class="col-4">
                    <button type="button" pButton
                            label="[Empty List]"
                            icon="pi pi-trash"
                            class="p-button-danger p-button-sm p-button-text underline"
                            (confirmDelete)="deleteAll()"></button>
                </div>
            </div>
        </ng-template>

        <p-orderList [value]="section.cards"
                     controlsPosition="right"
                     [listStyle]="{'max-height':'18rem'}">
            <ng-template let-card pTemplate="item">
                <div class="grid">
                    <div class="col-1">
                        <ng-container [ngSwitch]="card.type">
                            <div *ngSwitchCase="'COURSE'">
                                <img src="assets/images/ic_golf.png" width="16">
                            </div>
                            <div *ngSwitchCase="'LEISURE'">
                                <img src="assets/images/ic_ticket.png" width="16">
                            </div>
                            <div *ngSwitchDefault>
                                <img src="assets/images/ic_banner.png" width="16">
                            </div>
                        </ng-container>
                    </div>
                    <div class="col-9 text-sm">
                        {{card?.title}}
                    </div>
                    <div class="col-2">
                        <div class="flex gap-2 justify-content-end">
                            <button type="button" pButton
                                    icon="pi pi-pencil"
                                    (click)="edit(card)"
                                    class="p-button-info p-button-sm p-button-outlined z-1"></button>
                            <button type="button" pButton
                                    icon="pi pi-trash"
                                    class="p-button-danger p-button-sm p-button-outlined z-1"
                                    (confirmDelete)="delete(card)"></button>
                        </div>
                    </div>
                </div>
            </ng-template>
        </p-orderList>
        <p-card class="mt-5">
            <div class="bold text-center text-green-500 underline">
                ADD NEW ITEMS
            </div>
            <p-tabView>
                <p-tabPanel header="Course">
                    <div class="flex flex-wrap gap-3">
                        <div>
                            <p-multiSelect
                                [options]="courseOptions$| async"
                                [(ngModel)]="selectedCourse"
                                group="true"
                                selectedItemsLabel="{0} items selected"
                                placeholder="Choose Course"
                                [maxSelectedLabels]="2"></p-multiSelect>
                        </div>
                        <div>
                            <button
                                pButton
                                class="p-button p-button-success p-button-rounded"
                                (click)="addCourses()"
                                icon="pi pi-plus"
                                [disabled]="!selectedCourse"
                            ></button>
                        </div>
                    </div>
                </p-tabPanel>

<!--                <p-tabPanel header="Tickets">-->
<!--                    <div class="flex flex-wrap gap-3">-->
<!--                        <div>-->
<!--                            <p-multiSelect-->
<!--                                [options]="ticketOptions$| async"-->
<!--                                [(ngModel)]="selectedTicket"-->
<!--                                group="true"-->
<!--                                selectedItemsLabel="{0} items selected"-->
<!--                                placeholder="Choose Tickets"-->
<!--                                [maxSelectedLabels]="2">-->
<!--                            </p-multiSelect>-->
<!--                        </div>-->
<!--                        <div>-->
<!--                            <button-->
<!--                                pButton-->
<!--                                class="p-button p-button-success p-button-rounded"-->
<!--                                (click)="addTickets()"-->
<!--                                icon="pi pi-plus"-->
<!--                                [disabled]="!selectedTicket"-->
<!--                            ></button>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </p-tabPanel>-->

                <p-tabPanel header="Button" *ngIf="listType == 'CAROUSEL'">
                    <div class="grid">
                        <div class="col-12">
                            <label>Title</label>
                            <input type="text" [(ngModel)]="newButton.title" pInputText/>
                        </div>

                        <div class="col-12">
                            <label>Image URL</label>
                            <input type="text" [(ngModel)]="newButton.imageUrl" pInputText/>
                        </div>

                        <div class="col-12">
                            <label>Route</label>
                            <app-route-select [(route)]="newButton.route"></app-route-select>
                        </div>

                        <div class="col-2">
                            <button pButton class="p-button-success p-button-rounded"
                                    (click)="addButton()"
                                    icon="pi pi-plus"
                                    [disabled]="!newButton.route || !newButton.imageUrl || !newButton.title">
                            </button>
                        </div>
                    </div>
                </p-tabPanel>

                <p-tabPanel header="Package">
                    <div class="flex flex-wrap gap-3">
                        <div>
                            <p-multiSelect
                                [options]="packageOptions$| async"
                                [(ngModel)]="selectedPackageInfo"
                                group="true"
                                selectedItemsLabel="{0} items selected"
                                placeholder="Choose Packages"
                                [maxSelectedLabels]="2">
                            </p-multiSelect>
                        </div>
                        <div>
                            <button
                                pButton
                                class="p-button p-button-success p-button-rounded"
                                (click)="addPackageInfo()"
                                icon="pi pi-plus"
                                [disabled]="!selectedPackageInfo"
                            ></button>
                        </div>
                    </div>
                </p-tabPanel>

            </p-tabView>
        </p-card>
    </p-panel>
    <div class="flex justify-content-end mt-3">
        <button type="button" pButton
                label="Update"
                class="p-button-success mb-2"
                (confirmSave)="save()"></button>
    </div>
</div>
<p-dialog #dialog header="Edit card" [(visible)]="displayEditCard" [style]="{width: '50vw', height: '500px'}">
    <div *ngIf="editCard" class="flex flex-column gap-3">
        <div>Title: <input type="text" [(ngModel)]="editCard.title" pInputText=""/></div>
        <div>Image Url: <input type="text" [(ngModel)]="editCard.imageUrl" pInputText=""/></div>
        <div>
            <app-route-select [(route)]="editCard.route"></app-route-select>
        </div>
    </div>
    <br>

    <p-footer>
        <button type="button" label="OK" class="prime-button" pButton="" (click)="displayEditCard=false"></button>&nbsp;
    </p-footer>
</p-dialog>






